import type {ReactElement} from 'react';
import {useEffect} from 'react';
import {useRef} from 'react';
import {shallowEqual} from 'react-redux';
import './modal-container.scss';
import {ModalRender} from '@Components/modal-render/modal-render';
import {useAppSelector} from '@/hooks';
import {v4 as uuidv4} from 'uuid';

export function ModalContainer(): ReactElement<any> {
  const modalContainerId = useRef(uuidv4());
  const modalIds = useAppSelector((state) => {
    return Object.keys(state.modals.modalsHashmap);
  }, shallowEqual);

  useEffect(() => {
    return (): void => {
      window.PMW.mountedModalContainerId = undefined;
    };
  }, []);

  window.PMW.mountedModalContainerId ??= modalContainerId.current;

  if (window.PMW.mountedModalContainerId !== modalContainerId.current) {
    return <></>;
  }

  return (
    <>
      {modalIds.map((modalId) => {
        return <ModalRender key={modalId} modalId={modalId} />;
      })}
    </>
  );
}

export const isModalOpen = (): boolean => {
  for (const [, modalData] of Object.entries(window.PMW.redux.store.getState().modals.modalsHashmap)) {
    if (modalData.isOpen) {
      return true;
    }
  }
  return false;
};
